import { ProceedIcon } from '@commenda/icons';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import React, { useEffect } from 'react';

const ThreadsBanner = ({ onClick }: { onClick: () => unknown }) => {
  return (
    <div
      onClick={onClick}
      className="rounded-lg cursor-pointer bg-threads w-full flex justify-between py-3 px-4 relative"
    >
      <img
        src="/icons/play.png"
        alt="play icon"
        className="w-[10%] min-w-[33px] h-auto absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      />
      <div className="text-white flex flex-col justify-between w-[38%] py-2 max-w-[118px]">
        <h3>Introducing Threads</h3>
      </div>
      <img
        className="w-[33%] h-auto"
        src="/app-shots/threads.png"
        alt="Threads <> Communication layer between the accountant and enterprise customers"
      />
    </div>
  );
};

type ChatRoomEmptyStateProps = {
  onFinishedReadingInstructions: () => unknown;
  title: string;
  description: string;
  youtubeLink: string;
  cta?: string;
};

const ChatRoomEmptyState = ({
  onFinishedReadingInstructions,
  description,
  title,
  youtubeLink,
  cta,
}: ChatRoomEmptyStateProps) => {
  const [isVideoVisible, setIsVideoVisible] = React.useState(false);
  const [played, setPlayed] = React.useState(false);

  useEffect(() => {
    if (!isVideoVisible) {
      setPlayed(false);
    }
  }, [isVideoVisible]);

  return (
    <>
      <Dialog open={isVideoVisible} onOpenChange={setIsVideoVisible}>
        <DialogContent className="min-w-[47vw] h-fit">
          <div className="flex flex-col">
            <DialogHeader>
              <DialogTitle>Introducing Threads</DialogTitle>
            </DialogHeader>
            <div className="border-b border-stroke-3 flex flex-col gap-6 p-3xl">
              {played && (
                <iframe
                  src={`${youtubeLink}&autoplay=1`}
                  title="YouTube video player"
                  frameBorder={0}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="w-full aspect-video rounded-lg"
                />
              )}
              {!played && <ThreadsBanner onClick={() => setPlayed(true)} />}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <div className="py-8 flex flex-col justify-between gap-16 px-6 bg-accent-blue-10 h-full">
        <div className="flex flex-col gap-2">
          <h2 className="text-neutral-1">{title}</h2>
          <p className="body-15-regular text-neutral-3 ">{description}</p>
        </div>

        <div className="h-full w-full flex items-center">
          <ThreadsBanner onClick={() => setIsVideoVisible(true)} />
        </div>

        <Button
          className="flex items-center gap-2 w-full bg-accent-blue-100 text-white"
          onClick={onFinishedReadingInstructions}
        >
          <span>{cta || 'Get started with Threads'} </span>
          <ProceedIcon className="h-4 w-4" color="#fff" />
        </Button>
      </div>
    </>
  );
};

export default ChatRoomEmptyState;
